import React, { useState, useRef, useEffect } from 'react';
import { filesize } from '@/utils';
import { useDispatch, useSelector } from 'react-redux';
import { setIsRemove } from '@/Store/Slices/ImageSlice';
import { closeModal } from '@/Store/Slices/ModalSlice';

export const Button = ({ text, onClick }) => (
  <button
    type='button'
    className='px-4 py-1 text-xs font-medium text-white bg-gray-600 rounded-sm focus:outline-none hover:bg-gray-700'
    onClick={onClick}
  >
    {text}
  </button>
);

export default ({ className, name, label, accept, errors = [], onChange }) => {
  const fileInput = useRef();
  const [file, setFile] = useState(null);
  const { isRemove } = useSelector(state => state.image);
  const dispatch = useDispatch()

  function browse() {
    fileInput.current.click();
  }

  function remove() {
    setFile(null);
    onChange(null);
    fileInput.current.value = null;
  }

  function handleFileChange(e) {
    const file = e.target.files[0];
    setFile(file);
    onChange(file);
  }

  useEffect(() => {
    if (isRemove) {
      dispatch(closeModal())
      dispatch(setIsRemove({isRemove: false}))
      remove()

    }
  }, [isRemove]);

  return (
    <div className={className}>
      {label && (
        <label className='form-label' htmlFor={name}>
          {label}:
        </label>
      )}
      <div className={`form-input p-0 ${errors.length && 'error'}`}>
        <input
          id={name}
          ref={fileInput}
          accept={accept}
          type='file'
          className='hidden'
          onChange={handleFileChange}
        />
        {!file && (
          <div className='p-2'>
            <Button text='Browse' onClick={browse} />
          </div>
        )}
        {file && (
          <div className='flex items-center justify-between p-2'>
            <div className='flex-1 pr-1'>
              {file.name}
              <span className='ml-1 text-xs text-gray-600'>
                ({filesize(file.size)})
              </span>
            </div>
            <Button text='Remove' onClick={remove} />
          </div>
        )}
      </div>
      {errors.length > 0 && <div className='form-error'>{errors}</div>}
    </div>
  );
};
